export const initialState = {
  businessInvites: [],
  businessInvitesLoading: false,
  businessInvitesError: null,
  nextTokens: { 1: null },
  newBusinessInvite: {},
  newBusinessInviteLoading: false,
  newBusinessInviteError: null,
  businessInvite: {},
  businessInviteLoading: false,
  businessInviteError: null,
};

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case "REQUEST_LIST_BUSINESS_INVITATION":
      return {
        ...state,
        request: action.payload.request,
        businessInvites: [],
        nextTokens:
          action.payload.page === 1
            ? initialState.nextTokens
            : state.nextTokens,
        nextToken: null,
        businessInvitesError: null,
        businessInvitesLoading: true,
      };
    case "SUCCESS_LIST_BUSINESS_INVITATION":
      return {
        ...state,
        request: null,
        businessInvites: action.payload.items,
        nextTokens: {
          ...state.nextTokens,
          [action.payload.nextPage]: action.payload.nextToken,
        },
        businessInvitesLoading: false,
      };
    case "ERROR_LIST_BUSINESS_INVITATION":
      return {
        ...state,
        request: null,
        businessInvitesLoading: false,
        businessInvitesError: action.error,
      };
    case "REQUEST_CREATE_BUSINESS_INVITATION":
      return {
        ...state,
        request: action.payload.request,
        newBusinessInvite: {},
        newBusinessInviteLoading: true,
        newBusinessInviteError: null,
      };
    case "CREATE_BUSINESS_INVITATION_SUCCESS":
      return {
        ...state,
        request: null,
        newBusinessInvite: action.payload.businessInvite,
        newBusinessInviteLoading: false,
      };
    case "CREATE_BUSINESS_INVITATION_ERROR":
      return {
        ...state,
        request: null,
        newBusinessInviteLoading: false,
        newBusinessInviteError: action.error,
      };
    case "REQUEST_ACTION_BUSINESS_INVITATION":
      return {
        ...state,
        request: action.payload.request,
        businessInvite: {},
        businessInviteLoading: true,
        businessInviteError: null,
      };
    case "ACTION_BUSINESS_INVITATION_SUCCESS":
      const actionBusinessInvite = action.payload.actionBusinessInvite;

      // Membuat salinan businessInvites yang diperbarui dengan memperbarui item yang sesuai pada indeks yang ditemukan
      const updatedBusinessInvites = state.businessInvites.map((invite) =>
        invite.id === actionBusinessInvite.id ? actionBusinessInvite : invite
      );

      return {
        ...state,
        request: null,
        businessInvite: action.payload.actionBusinessInvite,
        businessInvites: updatedBusinessInvites,
        businessInviteLoading: false,
      };
    case "ACTION_BUSINESS_INVITATION_ERROR":
      return {
        ...state,
        request: null,
        businessInviteLoading: false,
        businessInviteError: action.error,
      };
    case "CLEAR_BUSINESS_INVITATION":
      return {
        ...state,
        request: null,
        newBusinessInvite: {},
        newBusinessInviteLoading: false,
      };
    case "CLEAR_BUSINESS_INVITATION_ERROR":
      return {
        ...state,
        request: null,
        newBusinessInviteLoading: false,
        newBusinessInviteError: null,
      };

    case "CLEAR_ACTION_BUSINESS_INVITATION":
      return {
        ...state,
        request: null,
        businessInvite: {},
        businessInviteLoading: false,
        businessInviteError: null,
      };
    default:
      return state;
  }
};
